import { canUpgradeToUseFeature, validateFeatureFlag } from '../../../services/featureFlagService';
import { FEATURE_FLAG } from '../../../constants/general';
import { featureAccess, LimitedFeatureType } from '../../../services/appAccess.service';
import { FeatureAccess } from '../../../pages/AccountSettings/components/rolesAndPermissions/PermissionsList';
// import { useStore } from '../../../store';

export const validateAccountingReports = () => {
  const canShowCashFlowReport =
    validateFeatureFlag(FEATURE_FLAG.CASH_FLOW) || canUpgradeToUseFeature(FEATURE_FLAG.CASH_FLOW);
  const canShowProfitAndLoss =
    validateFeatureFlag(FEATURE_FLAG.PROFIT_AND_LOSS) || canUpgradeToUseFeature(FEATURE_FLAG.PROFIT_AND_LOSS);
  const canShowExpenseReport =
    validateFeatureFlag(FEATURE_FLAG.EXPENSE_REPORTS) || canUpgradeToUseFeature(FEATURE_FLAG.EXPENSE_REPORTS);
  const canShowScheduleC =
    validateFeatureFlag(FEATURE_FLAG.SCHEDULE_C) || canUpgradeToUseFeature(FEATURE_FLAG.SCHEDULE_C);
  return canShowCashFlowReport || canShowProfitAndLoss || canShowExpenseReport || canShowScheduleC || false;
};
export const validateSendMoney = (): boolean => {
  const canSendACHLinkedAccount =
    featureAccess(null, LimitedFeatureType.SendMoneyACHLinkedAccount) !== FeatureAccess.NONE;
  const canSendACH =
    featureAccess(FEATURE_FLAG.ACH_OUT_TRANSFER, LimitedFeatureType.SendMoneyACH) !== FeatureAccess.NONE;
  const canSendWireOut =
    featureAccess(FEATURE_FLAG.DOMESTIC_WIRE_OUT, LimitedFeatureType.SendMoneyWireOut) !== FeatureAccess.NONE;
  const canSendMailACheck =
    featureAccess(FEATURE_FLAG.MAIL_CHECK, LimitedFeatureType.SendMoneyMailACheck) !== FeatureAccess.NONE;
  const canPayABill = featureAccess(FEATURE_FLAG.BILL_PAY, LimitedFeatureType.SendMoneyPayBill) !== FeatureAccess.NONE;
  return canSendACHLinkedAccount || canSendACH || canSendWireOut || canSendMailACheck || canPayABill;
};
export const validateAddMoney = (): boolean => {
  const canAddACHLinkedAccount =
    featureAccess(null, LimitedFeatureType.AddMoneyACHLinkedAccount) !== FeatureAccess.NONE;
  const canAddDirectDeposit = featureAccess(null, LimitedFeatureType.AddMoneyACHDirectDeposit) !== FeatureAccess.NONE;
  const canAddWireTransfer =
    featureAccess(null, LimitedFeatureType.AddMoneyIncomingWireTransfer) !== FeatureAccess.NONE;
  const canAddCheckDeposit = featureAccess(null, LimitedFeatureType.AddMoneyCheckDeposit) !== FeatureAccess.NONE;
  return canAddACHLinkedAccount || canAddDirectDeposit || canAddWireTransfer || canAddCheckDeposit;
};
export const validateInvoices = () =>
  validateFeatureFlag(FEATURE_FLAG.INVOICE) || canUpgradeToUseFeature(FEATURE_FLAG.INVOICE);

export const validateTransactionsFaceLift = () => validateFeatureFlag(FEATURE_FLAG.TRANSACTIONS_FACELIFT);
export const validateAccountantAi = () => validateFeatureFlag(FEATURE_FLAG.ACCOUNTANT_AI);

export const validateBillPay = () =>
  validateFeatureFlag(FEATURE_FLAG.BILL_PAY) || canUpgradeToUseFeature(FEATURE_FLAG.BILL_PAY);

export const validateForm1065 = () => validateFeatureFlag(FEATURE_FLAG.ScheduleK) || canUpgradeToUseFeature(FEATURE_FLAG.ScheduleK);

export const validateFormScheduleC = () => validateFeatureFlag(FEATURE_FLAG.SCHEDULE_C) || canUpgradeToUseFeature(FEATURE_FLAG.SCHEDULE_C);

export const validateForm1120s = () => validateFeatureFlag(FEATURE_FLAG.Form1120s) || canUpgradeToUseFeature(FEATURE_FLAG.Form1120s);

export const validateForm1120 = () => validateFeatureFlag(FEATURE_FLAG.Form1120) || canUpgradeToUseFeature(FEATURE_FLAG.Form1120);

export const validateClientsAndProductsHub = (type: string, userSummary: any) => userSummary.actionFlags.createInvoice;

export const validateRoutingNumberChange = (userSummary: any, actionFlag: string) =>
  userSummary.actionFlags[actionFlag] && validateFeatureFlag(FEATURE_FLAG.PAYEES_MIGRATION_REPORT);
